<template>
  <el-card class="box-card">
    <el-row>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="1" style="padding:30px;">
            <h3>Vous n'avez toujours aucun produit de défini?</h3>
            <p>Créer dès aujourd'hui vos produits pour commencer à générer des revenus!</p>
            <el-button type="primary" @click="createNewItem">Ajouter des produits</el-button>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="1">
              <img class="items" src="/static/images/inventory/inventory-magementx200.png">
        </el-col>
    </el-row>
  </el-card>
</template>
<script>
import axios from "axios"

export default {
  data() {
    return {
    };
  },components: {

  },
	methods: {
    createNewItem(){
      this.$emit('createNewItem');
    }
	},
	computed: {

	}
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';


@media (max-width: 1024px) {
  img.items {
    margin-top:20px;
    height:175px;
  }
}
</style>
